<div class="vertical-filters" [ngClass]="{ collapsed: !isFiltersMenuOpen() }">
  <div class="vertical-filters-header">
    <img src="assets/images/common/filter.svg" (click)="onToggleClick()" alt="filter" />
    <div>Filters</div>
    <img
      src="assets/images/arrows/chevron.svg"
      class="vertical-filters-header-img"
      (click)="onToggleClick()"
      alt="toggle"
    />
  </div>
  <div class="vertical-filters-options">
    <div class="vertical-filters-options-container">
      <div *ngFor="let optionGroup of optionsInsideCategories(); let i = index">
        <div *ngIf="optionGroup.displayName && !optionGroup.isDynamic">
          <app-accordion
            [inMultiSelect]="true"
            [expanded]="expandedCategories()[optionGroup.displayName]"
            [accordionTitle]="optionGroup.displayName | beautifyDisplayString"
            (accordionExpansionEvent)="expandClicked(optionGroup.displayName, $event)"
          >
            <div
              *ngFor="let option of optionGroup.options"
              class="vertical-filters-option"
              [ngClass]="{
                'vertical-filters-option-selected': selectedIds().has(option.id) && !option.disabled,
                'vertical-filters-option-disabled': option.disabled,
              }"
              (click)="onSelect(option.id)"
            >
              <mat-checkbox
                color="primary"
                [checked]="selectedIds().has(option.id)"
                (click)="$event.stopPropagation()"
                (change)="onSelect(option.id)"
              >
              </mat-checkbox>
              <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" />
              <div *ngIf="!option.disabled" class="vertical-filters-option-text" appLongTextTooltip>
                {{
                  option.withoutBeautifyDisplayName ? option.displayName : (option.displayName | beautifyDisplayString)
                }}
              </div>
            </div>
          </app-accordion>
        </div>
      </div>
      <div>
        <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Actor">
          <app-autocomplete-api
            [searchValuesCtrl]="searchActorValuesCtrl"
            [pageFilters]="pageFilters()"
            [filteredValues]="filteredActorValues"
            [isLoading$]="isActorLoading$"
            [filterType]="actorFilterEnum"
            (optionOnSelection)="actorSubmitted($event)"
          >
          </app-autocomplete-api>
        </app-accordion>
        <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Environment Id">
          <div class="autocomplete-api">
            <input
              class="autocomplete-api-input"
              [formControl]="dynamicFilters.environment.control"
              [placeholder]="dynamicFilters.environment.placeholder"
              (keypress)="onEnvironmentIdKeyPress($event)"
            />
            <div class="static-images">
              <img
                class="icon clickable-icon"
                src="assets/images/common/search.svg"
                alt="search"
                (click)="onEnvironmentIdSearch()"
              />
            </div>
          </div>

          <!-- Selected environment ID values -->
          <div *ngIf="getSelectedEnvironmentOptions().length > 0">
            <div
              *ngFor="let value of getSelectedEnvironmentOptions()"
              class="autocomplete-api-option"
              [ngClass]="{
                'autocomplete-api-option-selected': selectedIds().has(value.id),
                'autocomplete-api-option-disabled': value.disabled,
              }"
              (click)="toggleEnvironmentSelection(value)"
            >
              <mat-checkbox
                color="primary"
                [checked]="selectedIds().has(value.id)"
                (click)="$event.stopPropagation()"
                (change)="toggleEnvironmentSelection(value)"
              >
                {{ value.displayName }}
              </mat-checkbox>
            </div>
          </div>
        </app-accordion>
        <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Thread Id">
          <div class="autocomplete-api">
            <input
              class="autocomplete-api-input"
              [formControl]="dynamicFilters.threadId.control"
              [placeholder]="dynamicFilters.threadId.placeholder"
              (keypress)="onThreadIdKeyPress($event)"
            />
            <div class="static-images">
              <img
                class="icon clickable-icon"
                src="assets/images/common/search.svg"
                alt="search"
                (click)="onThreadIdSearch()"
              />
            </div>
          </div>

          <!-- Selected thread ID values -->
          <div *ngIf="getSelectedThreadIdOptions().length > 0">
            <div
              *ngFor="let value of getSelectedThreadIdOptions()"
              class="autocomplete-api-option"
              [ngClass]="{
                'autocomplete-api-option-selected': selectedIds().has(value.id),
                'autocomplete-api-option-disabled': value.disabled,
              }"
              (click)="toggleThreadIdSelection(value)"
            >
              <mat-checkbox
                color="primary"
                [checked]="selectedIds().has(value.id)"
                (click)="$event.stopPropagation()"
                (change)="toggleThreadIdSelection(value)"
              >
                {{ value.displayName }}
              </mat-checkbox>
            </div>
          </div>
        </app-accordion>
      </div>
    </div>
  </div>
</div>
<div [ngClass]="{ collapsed: isFiltersMenuOpen() }">
  <img
    src="assets/images/arrows/filters-menu-closed.svg"
    (click)="onToggleClick()"
    class="collapsed-img"
    alt="collapse"
  />
</div>
